import { render, staticRenderFns } from "./HighlightedPickersModal.vue?vue&type=template&id=4b88d56c&"
import script from "./HighlightedPickersModal.vue?vue&type=script&lang=js&"
export * from "./HighlightedPickersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports